import type { SitePopup } from '@/services/popupsApi';

const prefix = 'autoqm:popup:';
export function koreaDay(now = new Date()): string {
  return new Date(now.getTime() + 9 * 60 * 60 * 1000).toISOString().slice(0, 10);
}
export function popupHidden(id: string, now = new Date()): boolean {
  try {
    const value = localStorage.getItem(prefix + id);
    if (value === 'forever' || value === koreaDay(now)) return true;
  } catch { /* Storage can be blocked in private or embedded browsers. */ }
  return false;
}
export function dismissPopup(popup: SitePopup, remember: boolean, now = new Date()): void {
  // Today dismissals must expire at KST midnight, even in the same tab.
  if (remember) {
    try { localStorage.setItem(prefix + popup.id, popup.dismiss_mode === 'forever' ? 'forever' : koreaDay(now)); } catch { /* In-memory close still works. */ }
  }
}
